import { ReactNode, createContext, useContext, useState } from 'react';

interface TenantObject {
  id: number;
  name: string;
  slug: string;
}

interface PartnerContextProps {
  selectedTenant: TenantObject;
  setSelectedTenant: (tenant: TenantObject) => void;
  reset: () => void;
}

interface PartnerProviderProps {
  children: ReactNode;
}

export const INITIAL_VALUE = -2;
export const DEFAULT_VALUE = -1;

const AuthContext = createContext<PartnerContextProps | undefined>(undefined);

const PartnerContext = ({ children }: PartnerProviderProps) => {
  const [selectedTenant, setSelectedTenant] = useState<TenantObject>({
    id: INITIAL_VALUE,
    name: '',
    slug: '',
  });

  const contextValue: PartnerContextProps = {
    selectedTenant,
    setSelectedTenant,
    reset: () => setSelectedTenant({ id: INITIAL_VALUE, name: '', slug: '' }),
  };

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};
const usePartnerContext = (): PartnerContextProps => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('Something went wrong.');
  }
  return context;
};

export { usePartnerContext, PartnerContext };
